import React from 'react'

import ItemDetail from './item'
import { StyledItemContainer, StyledItemsContainer } from './ItemsWmo.css'

const ItemsWmo = ({ data }) => (
  <StyledItemsContainer>
    {
      data.map(item => (
        <StyledItemContainer key={item?.product?.sku}>
          <ItemDetail item={item} />
        </StyledItemContainer>
      ))
      }
  </StyledItemsContainer>
)

export default ItemsWmo
